/** Base URL for all API calls. Empty when co-hosted, set via env var when deployed separately. */
export const API_BASE = process.env.NEXT_PUBLIC_API_URL || '';

/** Build an absolute API URL from a relative path. */
export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}
